import {TaxpayerDataCommon} from '../types';
import {localize} from 'mixins/helpers';
import React from 'react';
import dayjs from "mixins/dayjsConfig";

const CommonCategory = (props: {
  taxpayerData?: TaxpayerDataCommon;
  title: string;
  props: any;
}) => {
  const numberSeparator = (n: number | any) => {
    const numberFormatter = Intl.NumberFormat('ru-RU');
    return numberFormatter.format(n);
  };

  const { categoryTotalDebt, categoryMainDebt, categoryPenalty, categoryFine, categoryActCreateDate } = props.props.config;

  return (
    <>
      <tr>
        <td colSpan={2} align="center">
          <strong>{props.title} </strong>
        </td>
      </tr>

      <tr>
        <td>{categoryActCreateDate}</td>
        <td>
          {props.taxpayerData?.actCreateDate &&
              dayjs(props.taxpayerData?.actCreateDate).format('DD.MM.YYYY')}
        </td>
      </tr>
      <tr>
        <td>{categoryTotalDebt}</td>
        <td>
          {props.taxpayerData?.totalDebt &&
              numberSeparator(props.taxpayerData?.totalDebt) +
              ' ' +
              localize('units.tenge', props.props.translations)}
        </td>
      </tr>
      <tr>
        <td>{categoryMainDebt}</td>
        <td>
          {props.taxpayerData?.mainDebt &&
              numberSeparator(props.taxpayerData?.mainDebt) +
              ' ' +
              localize('units.tenge', props.props.translations)}
        </td>
      </tr>
      <tr>
        <td>{categoryPenalty}</td>
        <td>
          {props.taxpayerData?.penalty &&
              numberSeparator(props.taxpayerData?.penalty) +
              ' ' +
              localize('units.tenge', props.props.translations)}
        </td>
      </tr>
      <tr>
        <td>{categoryFine}</td>
        <td>
          {numberSeparator(props.taxpayerData?.fine) +
          ' ' +
          localize('units.tenge', props.props.translations)}
        </td>
      </tr>
    </>
  );
};

export default CommonCategory;
